<app-dialog-header title="Détail du cours"></app-dialog-header>

<mat-dialog-content>
  <div class="cours-header">
    <div class="cours-libelle">{{ jourCours.libelle }}</div>

    <div class="cours-infos">
      <div class="cours-info">
        <mat-icon color="primary">event</mat-icon>
        <span>{{ jourCours.date | date:'fullDate' | titlecase }}</span>
      </div>
      <div class="cours-info">
        <mat-icon color="primary">schedule</mat-icon>
        <span>{{ jourCours.heureDebut | slice:0:5 }} - {{ jourCours.heureFin | slice:0:5 }}</span>
      </div>
      <div *ngIf="jourCours.libelleSalle" class="cours-info">
        <app-icon icon="salle" type="do" class="primary">room</app-icon>
        <span>{{ jourCours.libelleSalle }}</span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading; else loader">
    <div *ngIf="!studentsList.length" class="no-eleves">
      {{ 'planning_enseignant.pointage_eleves.no_eleves' | trans }}
    </div>

    <ul *ngIf="studentsList.length" class="student-list-items">
      <li *ngFor="let student of studentsList" class="student-item">
        <mat-icon class="student-icon" color="primary">person</mat-icon>
        <span class="student-name">{{ student.nomReferent }}</span>
        <span *ngIf="student.heureDebut && student.heureFin" class="student-horaires">
          ({{ student.heureDebut | slice:0:5 }} - {{ student.heureFin | slice:0:5 }})
        </span>
      </li>
    </ul>
  </ng-container>

  <ng-template #loader>
    <app-loader message="Chargement..."></app-loader>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close>Fermer</button>
</mat-dialog-actions>
